import React, { useState } from "react";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function profilePhotoSrc(photoUrl) {
  if (!photoUrl) return null;
  if (/^https?:\/\//.test(photoUrl)) return photoUrl;
  return `${BACKEND_URL}${photoUrl}`;
}

// Avatar publik dari Cloud. Hanya render <img> bila photoUrl ada;
// selain itu langsung inisial (tidak tebak URL → tidak ada request 404 sia-sia).
// Bila onSelect diisi, avatar jadi clickable (label + input file tersembunyi).
export function ProfileAvatar({ userId, photoUrl, name, className, fallbackClassName, onSelect, inputTestId, disabled }) {
  const [failed, setFailed] = useState(false);
  void userId;
  const src = profilePhotoSrc(photoUrl);
  const initial = (name || "P")[0].toUpperCase();
  const box = className || "h-16 w-16 rounded-full flex-shrink-0 border border-brand-100";
  const fb = fallbackClassName || "h-16 w-16 rounded-full bg-brand-100 grid place-items-center text-2xl font-bold text-brand-700 flex-shrink-0";
  const fallback = <div className={fb}>{initial}</div>;
  const visual = src && !failed ? (
    <img
      src={src}
      alt={name || "Foto profil"}
      className={`${box} object-cover`}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  ) : fallback;

  if (!onSelect) return visual;

  return (
    <label
      className={`relative inline-block ${disabled ? "opacity-60 pointer-events-none" : "cursor-pointer group"}`}
      title="Ganti foto profil"
    >
      {visual}
      <span className="absolute inset-0 rounded-full bg-black/0 group-hover:bg-black/30 transition flex items-center justify-center">
        <span className="opacity-0 group-hover:opacity-100 text-white text-xs font-bold bg-black/60 rounded-full px-2 py-1">
          Ganti
        </span>
      </span>
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        disabled={disabled}
        onChange={(e) => {
          const f = e.target.files?.[0];
          e.target.value = "";
          onSelect(f);
        }}
        data-testid={inputTestId || "profile-photo-input"}
      />
    </label>
  );
}
